<div class="container-fluid mt-3">
  <div class="row no-gutters">
    <div class="col-3 bold px-1 pl-5 name-header">Name</div>
    <div class="col-4 bold px-1">Role</div>
    <div class="col-3 bold px-1">Conditions to Check</div>
    <div
      class="col-2 d-flex flex-nowrap justify-content-end align-items-center"
    >
      <button mat-icon-button (click)="addNew()">
        <mat-icon class="yellow">add_box</mat-icon>
      </button>
    </div>
  </div>
  <div cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="drop($event)">
    <div *ngFor="let r of roleNotificationSettings">
      <div class="row no-gutters setting-row" cdkDrag>
        <div class="col-3 px-1 d-flex">
          <mat-icon class="yellow m-2 drag-handle" cdkDragHandle
            >reorder</mat-icon
          >
          <mat-form-field
            appearance="outline"
            class="no-subscript"
            [ngClass]="{ deleted: r.id < 0 }"
          >
            <input
              matInput
              [(ngModel)]="r.name"
              [disabled]="r.disabled"
              [placeholder]="r.name ? '' : 'Enter a Name'"
            />
          </mat-form-field>
        </div>
        <div class="col-4 px-1">
          <mat-form-field
            class="roles no-subscript"
            [ngClass]="{ deleted: r.id < 0 }"
          >
            <mat-chip-grid
              #chipGrid
              aria-label="Selected role"
              [disabled]="r.disabled"
            >
              <!-- Show the selected role as a chip -->
              <mat-chip-row *ngIf="r?.role" (removed)="clearRole(r)">
                {{ r.role?.name }}
                <role-chips
                  class="ml-1"
                  [roleCodes]="r.role?.code ?? ''"
                ></role-chips>
                <button
                  matChipRemove
                  aria-label="Remove role"
                  *ngIf="!r.disabled"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>

              <!-- The input stays inside the chip grid and drives the autocomplete -->
              <input
                [class.chip-input-hidden]="!!r?.role"
                #roleInput
                [disabled]="r?.disabled ?? false"
                [matAutocomplete]="auto"
                [matChipInputFor]="chipGrid"
                [matChipInputSeparatorKeyCodes]="[]"
                [matChipInputAddOnBlur]="false"
                (input)="filterRoles($event)"
                [(ngModel)]="roleQuery"
                (keydown.backspace)="r?.role && clearRole(r)"
                [disabled]="r.disabled"
                [placeholder]="r.role ? '' : 'Select a Role'"
              />
            </mat-chip-grid>

            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayObject"
              (optionSelected)="onRoleSelected(r, $event)"
              autoActiveFirstOption
            >
              <mat-option *ngFor="let role of rolesFiltered" [value]="role">
                {{ role.name }}
                <role-chips [roleCodes]="role.code ?? ''"></role-chips>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-3 px-1">
          <mat-form-field
            id="conditionsBox"
            class="no-subscript mb-1 no-arrow-select"
            [ngClass]="{ deleted: r.id < 0 }"
          >
            <textarea
              class="pr-4"
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              [(ngModel)]="r.conditions"
              [disabled]="r.disabled"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="r.conditions ? '' : 'Conditions'"
            ></textarea>
            <button
              class="help-button"
              mat-icon-button
              [mat-menu-trigger-for]="conditionsMenu"
              color="primary"
              *ngIf="!r.disabled"
            >
              <mat-icon>help</mat-icon>
            </button>
            <mat-menu
              #conditionsMenu="matMenu"
              class="no-padding-menu conditions-menu"
              ><cl-editor-conditions-help
                [(condition)]="r.conditions"
                [conditions]="conditions"
                [formType]="formTypeEnum.RSF"
              ></cl-editor-conditions-help
            ></mat-menu>
          </mat-form-field>
        </div>
        <div class="col-2 d-flex flex-nowrap justify-content-end">
          <div
            [ngClass]="{ 'row-buttons': r.disabled && r.id > 0 && !r.changed }"
          >
            <button
              matTooltip="Edit"
              mat-icon-button
              (click)="edit(r)"
              *ngIf="r.disabled && r.id >= 0"
            >
              <mat-icon class="yellow">edit</mat-icon>
            </button>
            <button
              matTooltip="Accept"
              mat-icon-button
              [disabled]="!r.name && !r.role"
              (click)="save(); r.disabled = true"
              *ngIf="!r.disabled && r.id >= 0"
            >
              <mat-icon class="green" [ngClass]="{ gray: !r.name && !r.role }"
                >check_circle</mat-icon
              >
            </button>
            <button
              matTooltip="Cancel"
              mat-icon-button
              (click)="cancel(r)"
              *ngIf="!r.disabled && r.id >= 0"
            >
              <mat-icon class="red">cancel</mat-icon>
            </button>
            <button
              matTooltip="Delete"
              mat-icon-button
              (click)="r.id = -r.id; save()"
              *ngIf="r.disabled && r.id >= 0"
            >
              <mat-icon class="red">delete</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="r.id = -r.id; save()"
              *ngIf="r.disabled && r.id < 0"
            >
              <mat-icon
                matTooltip="Undelete"
                class="blue material-symbols-outlined"
                >restore_from_trash</mat-icon
              >
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
